// extracted by mini-css-extract-plugin
export default {"container":"EnrollResult_container__ggxXf"};